import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { store } from '../redux/configureStore';
import { getCwUrl, toQueryString, getGBUrl } from '../util/util';
import { getConfigObject } from '../util/config';
import { get, post } from './api';

const addCompletionCountDataToMyCourseResponse = async (
  courseId,
  data,
  propertyToLookUp = 'items'
) => {
  const IAM_JWT_CONFIG = getConfigObject().IAM_JWT_CONFIG || {
    appMetaDataKey: 'app_metadata',
  };
  const { user } = store.getState();
  const isStudent = _get(
    user,
    `${IAM_JWT_CONFIG.appMetaDataKey}.course_data.student`,
    []
  ).includes(courseId);

  if (isStudent) return data;

  const assignmentIds = data[propertyToLookUp]
    .filter(({ dueDate }) => !!dueDate)
    .map(({ id }) => id);

  const completionStatusInfo = assignmentIds.length
    ? await getAssignmentCompletion(courseId, assignmentIds)
    : [];

  const completionStatusIdMap = completionStatusInfo.reduce(
    (map, { assignmentId, ...info }) => ({ ...map, [assignmentId]: info }),
    {}
  );

  data[propertyToLookUp] = data[propertyToLookUp].map((assignment) => ({
    ...assignment,
    ...completionStatusIdMap[assignment.id],
  }));

  return data;
};

export const getTimelineViewItems = async (courseId, searchObject) => {
  const data = await get(
    `/api/v1/myCourse/${courseId}/timeline${toQueryString(searchObject)}`,
    getCwUrl()
  );
  return addCompletionCountDataToMyCourseResponse(courseId, data);
};

export const getAssignmentCompletion = async (courseId, assignmentIds = []) => {
  try {
    const gradebookV1Url = '/api/v1';
    const completionCountV2 = `${gradebookV1Url}/courses/${courseId}/assignments/aggregate-completion-statuses`;
    const data = await post(completionCountV2, { assignmentIds }, getGBUrl());
    return _get(data, 'assignmentCompletionStatuses', []);
  } catch (_error) {
    return [];
  }
};

export const getCourseView = async (courseId, assignmentViewId) => {
  const data = await get(
    `/api/v1/lms/courses/${courseId}/views/${assignmentViewId}`,
    getCwUrl()
  );
  return data;
};

export const getCourseAssignments = async (courseId) => {
  const data = await get(`/api/v1/courses/${courseId}/assignments`, getCwUrl());
  return data;
};

export const getCourseInfo = async (courseId) => {
  const data = await get(`/api/v1/course/${courseId}`, getCwUrl());
  return data;
};
